<app-base-modal [open]="open" (openChange)="openChange.emit($event)" title="Join group" size="md">
  <div class="space-y-4">
    <div>
      <!--      <p class="text-sm font-semibold text-secondary">Invite link detected</p>-->
      <h2 class="mt-1 text-xl font-bold text-gray-900">Request access to</h2>
      @if (group) {
        <div class="mt-3 rounded-lg bg-blue-50 px-4 py-3 border border-blue-200">
          <p class="text-sm text-blue-900">
            <span class="font-semibold">Group:</span> {{ group.name }}
          </p>
          @if (group.description) {
            <p class="mt-1 text-sm text-blue-800">{{ group.description }}</p>
          }
        </div>
      }
      <p class="mt-2 text-sm text-gray-600">
        You opened a group invite link. Submit a request to join the group.
      </p>
    </div>

    <div class="rounded-xl border border-slate-200 bg-slate-50 p-4">
      <p class="text-xs font-semibold uppercase tracking-wide text-slate-500">Invite token</p>
      <p class="mt-2 break-all font-mono text-sm text-slate-800">
        {{ inviteToken || 'Missing token' }}
      </p>
    </div>

    @if (errorMessage) {
      <div class="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
        {{ errorMessage }}
      </div>
    }

    <div class="flex items-center justify-end gap-3 pt-2">
      <button
        type="button"
        class="rounded-lg bg-slate-100 px-4 py-2 text-sm font-semibold text-slate-700 transition-colors hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-70"
        (click)="close()"
        [disabled]="requesting"
      >
        Cancel
      </button>
      <button
        type="button"
        class="rounded-lg bg-secondary px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-hover disabled:cursor-not-allowed disabled:opacity-70"
        (click)="requestJoin()"
        [disabled]="requesting || !inviteToken"
      >
        {{ requesting ? 'Requesting...' : 'Request join' }}
      </button>
    </div>
  </div>
</app-base-modal>
